
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message } from "element-ui";

    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            code: '',
            apply_no: '',
            // product_no: '',
            // sdk_type: '',
            action: '',
            status: '',
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };
        status = {
            0: "未发送",
            1: "队列中",
            10: "已成功",
            20: "已失败"
        }

        getStatus(type: number) {
            if (type == 1) {
                return "warning";
            }
            if (type == 10) {
                return "success";
            }
            if (type == 20) {
                return "danger";
            }
            if (type == 0) {
                return "info";
            }
        }

        toCallback(code: string) {
            this.$confirm("确认要重发？", "提示", {
                type: "warning",
            }).then(async () => {
                this.loading = true;
                api.post('A16003', {code}).then(res => {
                    this.$message.success('操作成功')
                    this.searchTable()
                }).finally(() => {
                    this.loading = false;
                })

            })
        }

        // 查看
        detailDialog = false
        detailInfo = {}
        toDetail(code: any) {
            api.post('A16002', {code}).then(res => {
                this.detailInfo = res
                this.detailDialog = true
            })
        }

        // 搜索 search:true 重置翻页
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A16001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        activated() {
            this.searchTable();
        }
    }
